<template>
  <appCdialog
    ref="cDialog"
    v-bind="$attrs"
    top="10vh"
    title="应用分类个性化"
    v-on="$listeners"
    width="900px"
  >
    <div class="app-personal-warp">
      <div class="app-personal-left">
        <div class="left-top-warp">
          <span class="app-btn">
            <i class="el-icon-refresh-left"></i>
            <span class="app-name">还原设置</span>
          </span>
          <span class="app-btn">
            <i class="el-icon-plus"></i>
            <span class="app-name" @click="doTypeAdd">添加分类</span>
          </span>
        </div>
        <div class="left-content-warp">
          <span
            class="type-item"
            v-for="item in typeLists"
            :key="item.id"
            :class="{ active: item.id == typeId }"
            @click="changeType(item)"
          >
            <span class="type-name">{{ item.name }}</span>
            <span class="type-icon">
              <i class="el-icon-edit" @click.stop="doTypeEdit(item)"></i>
              <i class="el-icon-delete" @click.stop="doTypeDelete(item)"></i>
            </span>
          </span>
        </div>
      </div>
      <div class="app-personal-right">
        <div class="right-top-warp">
          <span class="app-btn">
            <i class="el-icon-plus"></i>
            <span class="app-name" @click="addApppShow = true">添加应用</span>
          </span>
        </div>
        <div class="right-table-warp">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="name"
              label="应用名称"
              width="140"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sort"
              label="显示顺序"
              width=""
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="拖动排序"
              class="move"
              width="100"
              align="center"
            >
              <i class="el-icon-rank" style="cursor: move"></i>
            </el-table-column>
          </el-table>
        </div>
        <div class="right-btn-warp">
          <el-button class="curr-36"> 确定 </el-button>
          <el-button class="cancle-36"> 取消 </el-button>
        </div>
      </div>
    </div>
    <addApplication
      v-if="addApppShow"
      :visible.sync="addApppShow"
    ></addApplication>
    <addAppType v-if="addTypeShow" :visible.sync="addTypeShow" :appItem="appItem"></addAppType>
  </appCdialog>
</template>

<script>
import appCdialog from "@/components/sys/dialog/dialog.vue";
import sortablejs from "sortablejs";
import addApplication from "./addApplication.vue";
import addAppType from "./addAppType.vue";
export default {
  components: { appCdialog, addApplication, addAppType },
  data() {
    return {
      typeLists: [
        { id: 1, name: "收藏" },
        { id: 2, name: "最近使用" },
        { id: 3, name: "未分类" },
        { id: 4, name: "人事有关" },
        { id: 5, name: "科研研究" },
        { id: 6, name: "财务收支" },
        { id: 7, name: "教育教学" },
      ],
      typeId: 1,
      tableData: [
        { id: 1, name: "教务系统", sort: "1" },
        { id: 2, name: "学工系统", sort: "2" },
      ],
      addApppShow: false,
      addTypeShow: false,
      appItem: {}
    };
  },
  mounted() {
    this.initSortable();
  },
  methods: {
    /** 关闭 */
    closeSchedule() {
      this.$refs.cDialog.handleClose();
    },
    /** 改变应用列表展示 */
    changeType(item) {
      this.typeId = item.id;
    },
    /** 编辑类型 */
    doTypeEdit(item) {
      this.appItem = item
      this.addTypeShow = true
    },
    /** 添加类型 */
    doTypeAdd() {
      this.appItem = {}
      this.addTypeShow = true
    },
    doTypeDelete() {},
    /** 表格拖拽事件 */
    initSortable() {
      // 获取表格row的父节点
      this.$nextTick(() => {
        const ele = document.querySelector(".el-table__body-wrapper tbody");
        const _this = this;
        // 创建拖拽实例
        sortablejs.create(ele, {
          animation: 1000,
          // 开始拖动事件
          onStart: () => {
            // console.log("开始拖动");
          },
          // 结束拖动事件
          onEnd: (e) => {
            let tableDatas = JSON.parse(JSON.stringify(_this.tableData));
            const currRow = tableDatas.splice(e.oldIndex, 1)[0];
            tableDatas.splice(e.newIndex, 0, currRow);
            console.log(tableDatas);
          },
        });
      });
    },
  },
};
</script>

<style lang='less' scoped>
.app-personal-warp {
  width: 100%;
  height: 460px;
  .app-personal-left {
    float: left;
    width: 240px;
    height: 100%;
    border-right: 1px solid #d9d9d9;
    padding-left: 20px;
    .left-top-warp {
      height: 55px;
      width: 100%;
      padding-right: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #072039;
      border-bottom: 1px solid #d9d9d9;
      .app-btn {
        cursor: pointer;
        .app-name {
          margin-left: 4px;
        }
      }
    }
    .left-content-warp {
      height: calc(100% - 55px);
      width: 100%;
      overflow-x: hidden;
      .type-item {
        float: left;
        width: 100%;
        padding-left: 20px;
        padding-right: 25px;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #072039;
        font-size: 14px;
        border-bottom: 1px solid #f1f1f3;
        cursor: pointer;
        .type-icon {
          width: 56px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .active {
        background: #f1f4fa;
      }
    }
  }
  .app-personal-right {
    float: left;
    height: 100%;
    width: calc(100% - 240px);
    padding-right: 20px;
    .right-top-warp {
      height: 55px;
      line-height: 55px;
      width: 100%;
      text-align: right;
      color: #200319;
      .app-btn {
        cursor: pointer;
      }
    }
    .right-table-warp {
      height: calc(100% - 55px - 70px);
      padding-left: 20px;
    }
    .right-btn-warp {
      height: 36px;
      line-height: 36px;
      text-align: right;
      margin-bottom: 32px;
    }
  }
}
</style>